import { getItem, setItem } from './localStorage'

const PARTNER_SOLUTIONS_CACHE_TTL_SECONDS = 6 * 60 * 60
const PARTNER_SOLUTIONS_CACHE_KEY_PREFIX = 'oppsync_partner_solutions_'

const getPartnerSolutionsCacheKey = (partnerId: string) =>
  `${PARTNER_SOLUTIONS_CACHE_KEY_PREFIX}${partnerId}`

const logCacheFailure = (operation: string, error: unknown): void => {
  console.warn('[PartnerSolutionsCache] Storage operation failed', {
    operation,
    errorName: error instanceof Error ? error.name : 'UnknownError',
    severity: 'info',
  })
}

export const invalidatePartnerSolutionsCache = (): void => {
  try {
    const keysToRemove: string[] = []
    for (let index = 0; index < localStorage.length; index++) {
      const key = localStorage.key(index)
      if (key?.startsWith(PARTNER_SOLUTIONS_CACHE_KEY_PREFIX)) {
        keysToRemove.push(key)
      }
    }
    keysToRemove.forEach(key => localStorage.removeItem(key))
  } catch (error) {
    logCacheFailure('invalidate', error)
  }
}

export const getCachedPartnerSolutions = async (
  partnerId: string
): Promise<unknown | undefined> => {
  try {
    return await getItem(getPartnerSolutionsCacheKey(partnerId))
  } catch (error) {
    logCacheFailure('read', error)
    return undefined
  }
}

export const cachePartnerSolutions = async (
  partnerId: string,
  data: unknown
): Promise<void> => {
  try {
    await setItem(getPartnerSolutionsCacheKey(partnerId), data, {
      ttlInSeconds: PARTNER_SOLUTIONS_CACHE_TTL_SECONDS,
    })
  } catch (error) {
    logCacheFailure('write', error)
  }
}
